/**
 * Generated from ch1_p01-02.fla
 */
export function ch1_p0102(this: Ich1_p0102) {
	const sky = this.sky;
	ch1_p0102_chp1_p01_sky.call(this.sky);
	sky.x = 0;
	sky.y = 0;
	sky.width = 1664.00;
	sky.height = 768.00;
	sky.alpha = 1.00;
	if (sky.onLayout) sky.onLayout();
	const treeBack = this.treeBack;
	ch1_p0102_chp1_p01_treeback.call(this.treeBack);
	treeBack.x = 0;
	treeBack.y = 0;
	treeBack.width = 1664.01;
	treeBack.height = 768.00;
	treeBack.alpha = 1.00;
	if (treeBack.onLayout) treeBack.onLayout();
	const bushes = this.bushes;
	ch1_p0102_chp1_p01__bushes.call(this.bushes);
	bushes.x = 535.75;
	bushes.y = 604.5;
	bushes.width = 544.50;
	bushes.height = 327.00;
	bushes.alpha = 1.00;
	if (bushes.onLayout) bushes.onLayout();
	const houseBack = this.houseBack;
	ch1_p0102_chp1_p01_houseback.call(this.houseBack);
	houseBack.x = 879.5;
	houseBack.y = 425.75;
	houseBack.width = 647.00;
	houseBack.height = 684.50;
	houseBack.alpha = 1.00;
	if (houseBack.onLayout) houseBack.onLayout();
	const houseFront = this.houseFront;
	ch1_p0102_chp1_p01_housefront.call(this.houseFront);
	houseFront.x = 0;
	houseFront.y = 0;
	houseFront.width = 1663.50;
	houseFront.height = 768.00;
	houseFront.alpha = 1.00;
	if (houseFront.onLayout) houseFront.onLayout();
	const treeFront = this.treeFront;
	ch1_p0102_chp1_p01_treefront.call(this.treeFront);
	treeFront.x = 0;
	treeFront.y = 0;
	treeFront.width = 777.00;
	treeFront.height = 768.00;
	treeFront.alpha = 1.00;
	if (treeFront.onLayout) treeFront.onLayout();
	const fence = this.fence;
	ch1_p0102_chp1_p01_fence.call(this.fence);
	fence.x = 535.5;
	fence.y = 383.5;
	fence.width = 1071.00;
	fence.height = 769.00;
	fence.alpha = 1.00;
	if (fence.onLayout) fence.onLayout();
	const rooster = this.rooster;
	ch1_p0102_chp1_p01_rooster.call(this.rooster);
	rooster.x = 491.75;
	rooster.y = 721.5;
	rooster.width = 354.50;
	rooster.height = 436.50;
	rooster.alpha = 1.00;
	if (rooster.onLayout) rooster.onLayout();
	const lightLeak = this.lightLeak;
	ch1_p0102_chp1_p01_lightleak.call(this.lightLeak);
	lightLeak.x = 512.75;
	lightLeak.y = 384;
	lightLeak.width = 1082.50;
	lightLeak.height = 768.00;
	lightLeak.alpha = 0.34;
	if (lightLeak.onLayout) lightLeak.onLayout();
	const frame = this.frame;
	ch1_p0102_Frame.call(this.frame);
	frame.x = 832;
	frame.y = 386.5;
	frame.width = 1664.00;
	frame.height = 773.00;
	frame.alpha = 1.00;
	if (frame.onLayout) frame.onLayout();
	const lineArt = this.lineArt;
	ch1_p0102_fadinglineart.call(this.lineArt);
	lineArt.x = 832;
	lineArt.y = 386.5;
	lineArt.width = 1664.00;
	lineArt.height = 763.00;
	lineArt.alpha = 0.64;
	if (lineArt.onLayout) lineArt.onLayout();
	return this;
}
function ch1_p0102_chp1_p01_sky(this: Ich1_p0102_chp1_p01_sky) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_sky.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_treeback(this: Ich1_p0102_chp1_p01_treeback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_treeback.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01__bushes(this: Ich1_p0102_chp1_p01__bushes) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01__bushes", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_houseback(this: Ich1_p0102_chp1_p01_houseback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_houseback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_housefront(this: Ich1_p0102_chp1_p01_housefront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_housefront.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_treefront(this: Ich1_p0102_chp1_p01_treefront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_treefront.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_fence(this: Ich1_p0102_chp1_p01_fence) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_fence", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_rooster(this: Ich1_p0102_chp1_p01_rooster) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_rooster", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p0102_chp1_p01_lightleak(this: Ich1_p0102_chp1_p01_lightleak) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp1_p01_lightleak", 0.474, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p0102_Frame(this: Ich1_p0102_Frame) {
	if (this.setLayoutTexture) this.setLayoutTexture("Frame", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p0102_fadinglineart(this: Ich1_p0102_fadinglineart) {
	if (this.setLayoutTexture) this.setLayoutTexture("fadinglineart", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p0102Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p0102Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p0102Sprite extends Ich1_p0102Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p0102Text extends Ich1_p0102Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p0102Polygon extends Array<number> {
}
interface Ich1_p0102 {
	readonly sky: Ich1_p0102_chp1_p01_sky;
	readonly treeBack: Ich1_p0102_chp1_p01_treeback;
	readonly bushes: Ich1_p0102_chp1_p01__bushes;
	readonly houseBack: Ich1_p0102_chp1_p01_houseback;
	readonly houseFront: Ich1_p0102_chp1_p01_housefront;
	readonly treeFront: Ich1_p0102_chp1_p01_treefront;
	readonly fence: Ich1_p0102_chp1_p01_fence;
	readonly rooster: Ich1_p0102_chp1_p01_rooster;
	readonly lightLeak: Ich1_p0102_chp1_p01_lightleak;
	readonly frame: Ich1_p0102_Frame;
	readonly lineArt: Ich1_p0102_fadinglineart;
}
interface Ich1_p0102_chp1_p01_sky extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_treeback extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01__bushes extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_houseback extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_housefront extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_treefront extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_fence extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_rooster extends Ich1_p0102Sprite {
}
interface Ich1_p0102_chp1_p01_lightleak extends Ich1_p0102Sprite {
}
interface Ich1_p0102_Frame extends Ich1_p0102Sprite {
}
interface Ich1_p0102_fadinglineart extends Ich1_p0102Sprite {
}
